import { ArrowDropDown } from '@mui/icons-material';
import type { ButtonProps } from '@mui/material';
import { Button, MenuItem } from '@mui/material';
import { useIsMobile } from '../hooks/use-is-mobile';
import { ActionsMenu } from './actions-menu';
export interface TicketTypeOption {
  value: number;
  label: React.ReactNode;
  /**
   * Greys the option out (e.g. a sold-out type). The selected option is never
   * disabled, so a ticket can always stay on its current type.
   */
  disabled?: boolean;
}
export const TicketTypeSelector = ({
  selectedTicketType,
  setSelectedTicketType,
  ticketTypeOptions,
  variant = 'contained'
}: {
  selectedTicketType: number;
  setSelectedTicketType: (ticketType: number) => void;
  ticketTypeOptions: TicketTypeOption[];
  variant?: ButtonProps['variant'];
}) => {
  const isMobile = useIsMobile();
  return <ActionsMenu button={<Button variant={variant} color="monochrome" size="small" sx={isMobile ? {
    height: 26
  } : undefined} endIcon={ticketTypeOptions.length > 1 ? <ArrowDropDown /> : null}>
          {ticketTypeOptions.find(i => i.value === selectedTicketType)?.label}
        </Button>}>
      {ticketTypeOptions.map(option => <MenuItem key={option.value} selected={selectedTicketType === option.value} disabled={!!option.disabled && selectedTicketType !== option.value} onClick={() => {
      setSelectedTicketType(option.value);
    }} sx={theme => ({
      // Fully rounded (pill) hover to match the button style; selected
      // items use a neutral highlight instead of the light-orange tint.
      borderRadius: '999px',
      '&.Mui-selected': {
        backgroundColor: 'transparent'
      },
      '&.Mui-selected:hover': {
        backgroundColor: theme.palette.action.hover
      }
    })}>
          {option.label}
        </MenuItem>)}
    </ActionsMenu>;
};